export const API_ENDPOINT = 'https://api.qrc.az';
export const fetchOPT = {
    /* mode:'cors',redirect:'follow',headers:{'X-InvestAZ-Token':window.TOKEN} */
};